import axios from "axios";
import React, { useState, useEffect } from "react";
import { HeaderWrapper } from "../Components/Core/Core.styles";
import PageHeader from "../Components/PageHeader/PageHeader";
import TransactionTableUnre from "../Components/TransactionTableUnre/TransactionTableUnre";
import {
  PaginationWrapper,
} from "../Components/Pagination/Pagination.styles";
import Spinner from "../Assets/SpinBrokerSpin.gif";
import {
  NoteButton
} from '../Components/ModalTableUnrecoConfirm/ModalTableUnrecoConfirm.styles';
import Modal from "react-modal";
import { CloseButton } from "../Components/Modal/Modal.styles";
const baseURL = process.env.REACT_APP_API_URL;
const UnrecoTrans = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [csvModalIsOpen, setCsvModalIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadButtonText, setUploadButtonText] = useState("Upload");

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5000);
  const token = window.localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const basePage = 1;

  useEffect(() => {
    setLoading(true);
    axios
      .get(baseURL + `/get-unreconcilied-payments/${limit}/${page}`, {
        headers: headers
      })
      .then((response) => {
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [limit, page, token]);

  if (!data && loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "0 auto",
        }}
      >
        <img src={Spinner} style={{ width: "4rem", height: "auto" }} />
      </div>
    );
  }

  if(!data) return null;


  // PAGINATION CODE IN CASE WE NEED THAT LATER
  //   const totalPages = Math.ceil(
  //     data.pagination.total / data.pagination.perPage
  //   );

  //   const maxTx = data.pagination.total;

  //   console.log(
  //     "you need",
  //     totalPages,
  //     "for",
  //     data.pagination.total,
  //     "results if you show",
  //     data.pagination.perPage,
  //     "at a time"
  //   );

  // const firstPage = 1;
  // const multiPages = [];
  // // additional pages based on total pages requried
  // const addPages = Array.from({ length: totalPages - firstPage }, (_, i) => i + firstPage);

  // // initial page
  // const initPage = Array.from([totalPages - firstPage],
  //    (i) => i + firstPage
  // );
  // console.log(initPage)
  
  // addPages.forEach((page) => {
  //   multiPages.push({ label: page, value: page });
  // });
  // initPage.forEach((page) => {
  //   multiPages.push({label: page, value: page });
  // });
  // console.log(multiPages[multiPages.length-1])
  // console.log(multiPages);
  const importCsv = () => {
    setCsvModalIsOpen(true);
  }

  const closeCsvModal = () => {
    setCsvModalIsOpen(false);
    setSelectedFile(null);
  }

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  }

  const handleUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append('csvFile', selectedFile);
      setIsUploading(true);
      axios.post(baseURL + '/upload-transaction-csv', formData, { headers: { ...headers } })
        .then(() => {
          setIsUploading(false);
          setIsUploaded(true);
          setUploadButtonText('Uploaded');
        });
    }
  }

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.28)",
    },
    content: {
      display: "flex",
      width: "500px",
      height: "250px",
      flexDirection: "column",
      inset: "25%",
      justifyContent: "flex-start",
      margin: "0 auto",
    },
  };

  return (
    <div>
      <HeaderWrapper>
        <PageHeader
          header="Un-Reconciled Transactions"
          blurb="Any bank transactions we were unable to automatically reconcile must be done manually. "
        />

      </HeaderWrapper>

      <div style={{margin: "1em 4em"}}>
          <NoteButton onClick={() => {importCsv()}} >Import Csv</NoteButton>
      </div>

      <Modal
        isOpen={csvModalIsOpen}
        onRequestClose={closeCsvModal}
        style={modalStyles}
      >
        <CloseButton onClick={closeCsvModal}>&#10006;</CloseButton>
        <div style={{ padding: "20px" }}>
          <h2 style={{ marginBottom: "20px" }}>Import CSV File</h2>
          <div style={{ marginBottom: "20px" }}>
            <input
              type="file"
              name="csvFile"
              accept=".csv"
              onChange={handleFileChange}
              style={{ marginBottom: "15px" }}
            />
            {selectedFile && (
              <p style={{ fontSize: "14px", color: "#666" }}>
                Selected file: {selectedFile.name}
              </p>
            )}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <NoteButton
              onClick={handleUpload}
              disabled={!selectedFile || isUploading || isUploaded}
              style={{
                opacity: (selectedFile && !isUploading && !isUploaded) ? 1 : 0.6,
                cursor: (selectedFile && !isUploading && !isUploaded) ? "pointer" : "not-allowed"
              }}
            >
              { uploadButtonText }
            </NoteButton>
            <NoteButton
              onClick={closeCsvModal}
              style={{
                padding: "0 20px",
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Cancel
            </NoteButton>
          </div>
        </div>
      </Modal>

      <PaginationWrapper style={{ width: "350px", margin: "0rem" }}>

      </PaginationWrapper>
      <TransactionTableUnre data={data} page={page} limit={limit}></TransactionTableUnre>
    </div>
  );
};

export default UnrecoTrans;
